import React, { Component } from 'react';
import PropTypes from 'prop-types';
// import { Input } from 'semantic-ui-react';
import styles from './range.css';
import {
  PRIMARY_COLOR,
  SECONDARY_COLOR,
  BLACK_COLOR,
  WHITE_COLOR,
} from '../../../colors';
import IncreaseButton from '../../../increaseButton';
import DecreaseButton from '../../../decreaseButton';
import { colorsModeUI } from '../../../modeUI';
import './index.css';

export default class ViewBasic extends Component {
  constructor(props) {
    super(props);
    this.rangeMouseDown = this.rangeMouseDown.bind(this);
    this.rangeMouseMove = this.rangeMouseMove.bind(this);
    this.rangeMouseUp = this.rangeMouseUp.bind(this);
    this.setValueByInput = this.setValueByInput.bind(this);
    this.calcularPosition = this.calcularPosition.bind(this);
    this.getPositionValues = this.getPositionValues.bind(this);
    this.setStateValuePosition = this.setStateValuePosition.bind(this);
    this.increase = this.increase.bind(this);
    this.decrease = this.decrease.bind(this);
    const { start } = props;
    this.state = {
      value: start,
      position: 0,
      mouseDown: false,
    };
  }

  componentDidMount() {
    const { start } = this.props;
    const position = this.calcularPosition(start);
    this.setStateValuePosition(start, position);
  }

  componentWillReceiveProps(nextProps) {
    const { start } = nextProps;
    const position = this.calcularPosition(start);
    this.setStateValuePosition(start, position);
  }

  /**
   * Set state value position
   * This function sets the states variables value and position
   * @param number value
   * @param number position
   */
  setStateValuePosition(value, position) {
    this.setState({
      value,
      position,
    });
  }

  /**
   * Set value by input
   * @param object event
   */
  setValueByInput(event) {
    const { value, position } = this.state;
    const { setValueByInput } = this.props;
    const { trackFillLeft, innerLeft, offsetWidth } = this.getPositionValues();
    const values = setValueByInput(
      event.target.value,
      trackFillLeft,
      innerLeft,
      offsetWidth,
      position,
      value
    );

    this.setStateValuePosition(values.value, values.position);
  }

  /**
   * Get position values
   * This function get the values used to calculate the slider position
   * @return object {
   *  object innerBoundingClientRect,
   *  number trackFillLeft,
   *  number innerLeft,
   *  number innerRight,
   *  number offsetWidth
   * }
   */
  getPositionValues() {
    const innerBoundingClientRect = this.inner.getBoundingClientRect();
    const trackFillLeft = this.trackFill.getBoundingClientRect().left;
    const innerLeft = this.inner.getBoundingClientRect().left;
    const innerRight = this.inner.getBoundingClientRect().right;
    const { offsetWidth } = this.inner;
    return {
      innerBoundingClientRect,
      trackFillLeft,
      innerLeft,
      innerRight,
      offsetWidth,
    };
  }

  /**
   * Calcular position
   * @param float value
   * @return float position
   */
  calcularPosition(value) {
    const { calcularPosition } = this.props;
    const { trackFillLeft, innerLeft, offsetWidth } = this.getPositionValues();
    return calcularPosition(trackFillLeft, innerLeft, offsetWidth, value);
  }

  /**
   * Range mouse down
   * @param bool isTouch
   * @param object e
   */
  rangeMouseDown(isTouch, e) {
    const { rangeMouseDown } = this.props;
    const { position, value } = this.state;
    const { offsetWidth, innerBoundingClientRect } = this.getPositionValues();
    const mouseDown = true;
    this.setState({ mouseDown });
    const values = rangeMouseDown(
      isTouch,
      e,
      innerBoundingClientRect,
      offsetWidth,
      position,
      value
    );
    this.setStateValuePosition(values.value, values.position);
  }

  /**
   * Range mouse up: this function is called by event onMouseUp
   */
  rangeMouseUp() {
    this.setState({ mouseDown: false });
  }

  /**
   * Range mouse move
   * @param bool isTouch
   * @param object e
   */
  rangeMouseMove(isTouch, e) {
    const { rangeMouseMove } = this.props;
    const { position, value, mouseDown } = this.state;
    const { innerLeft, innerRight } = this.getPositionValues();
    // @TODO
    // const { innerLeft, innerRight } = this;
    const values = rangeMouseMove(
      isTouch,
      e,
      innerLeft,
      innerRight,
      position,
      value,
      mouseDown
    );
    this.setStateValuePosition(values.value, values.position);
  }

  /**
   * Increase
   */
  increase() {
    const { value } = this.state;
    const { position } = this.state;
    const { step, setValueByInput, precision } = this.props;
    const valueNew =
      Math.round((parseFloat(value, 10) + step) * precision) / precision;
    const { trackFillLeft, innerLeft, offsetWidth } = this.getPositionValues();
    const values = setValueByInput(
      valueNew,
      trackFillLeft,
      innerLeft,
      offsetWidth,
      position,
      value
    );

    this.setStateValuePosition(values.value, values.position);
  }

  /**
   * Decrease
   */
  decrease() {
    const { value } = this.state;
    const { position } = this.state;
    const { step, setValueByInput, precision } = this.props;
    const valueNew =
      Math.round((parseFloat(value, 10) - step) * precision) / precision;
    const { trackFillLeft, innerLeft, offsetWidth } = this.getPositionValues();
    const values = setValueByInput(
      valueNew,
      trackFillLeft,
      innerLeft,
      offsetWidth,
      position,
      value
    );

    this.setStateValuePosition(values.value, values.position);
  }

  render() {
    const {
      disabled,
      backgroundColor,
      inverted,
      color,
      unit,
      offset,
      min,
      max,
      mode,
    } = this.props;
    const { value, position } = this.state;
    let colorText = inverted ? WHITE_COLOR : BLACK_COLOR;
    let colorBar =
      backgroundColor === 'none' ? SECONDARY_COLOR : backgroundColor;
    let colorBarMin = color === 'none' ? PRIMARY_COLOR : color;
    let colorBarFill = color === 'none' ? PRIMARY_COLOR : color;
    let colorThumb = color === 'none' ? PRIMARY_COLOR : color;
    let colorBarMax =
      backgroundColor === 'none' ? SECONDARY_COLOR : backgroundColor;

    if (mode !== null) {
      const modeColors = colorsModeUI(mode);
      colorText = modeColors.TEXT_COLOR;
      colorBar = modeColors.SLIDER_BAR;
      colorBarMin = modeColors.SLIDER_BAR_FILL;
      colorBarMax = modeColors.SLIDER_BAR;
      colorBarFill = modeColors.SLIDER_BAR_FILL;
      colorThumb = modeColors.SLIDER_BAR_FILL;
    }
    return (
      <div style={{ color: colorText }}>
        <div style={{ ...styles.label }}>
          <div id="thumbDisplay" style={styles.thumbDisplay}>
            <DecreaseButton decrease={this.decrease} mode={mode} />
            <input
              style={styles.thumbDisplayInput}
              value={value}
              onChange={(event) => this.setValueByInput(event)}
              className="input-slider-basic"
            />
            <div style={styles.thumbDisplayUnit}>{unit}</div>
            <IncreaseButton increase={this.increase} mode={mode} />
          </div>
        </div>
        <div
          id="sliderArea"
          style={{
            ...styles.range,
            ...(disabled ? styles.disabled : {}),
          }}
          onMouseDown={(event) => this.rangeMouseDown(false, event)}
          onMouseMove={(event) => this.rangeMouseMove(false, event)}
          onMouseUp={(event) => this.rangeMouseUp(false, event)}
          onTouchStart={(event) => this.rangeMouseDown(true, event)}
          onTouchMove={(event) => this.rangeMouseMove(true, event)}
        >
          <div
            className="semantic_ui_range_inner"
            ref={(inner) => {
              this.inner = inner;
            }}
            style={styles.inner}
          >
            <div
              id="min"
              style={{
                ...styles.line,
                ...{ left: '0px', backgroundColor: colorBarMin },
              }}
            />
            <div id="valueMin" style={styles.valueMin}>
              {`${min} ${unit}`}
            </div>
            <div
              style={{
                ...styles.track,
                ...(inverted && { opacity: 0.5 }),
                ...{ backgroundColor: colorBar },
              }}
            />
            <div
              ref={(trackFill) => {
                this.trackFill = trackFill;
              }}
              style={{
                ...styles.trackFill,
                ...{ backgroundColor: colorBarFill },
                ...{ width: `${position + offset}px` },
                ...(disabled ? styles.disabledTrackFill : {}),
              }}
            />
            <div
              id="thumb"
              style={{
                ...styles.thumb,
                ...{ backgroundColor: colorThumb },
                ...{ left: `${position}px` },
              }}
            />
            <div
              id="max"
              style={{
                ...styles.line,
                ...{ right: '0px', backgroundColor: colorBarMax },
              }}
            />
            <div id="valueMax" style={styles.valueMax}>
              {`${max} ${unit}`}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

ViewBasic.propTypes = {
  color: PropTypes.string,
  backgroundColor: PropTypes.string,
  inverted: PropTypes.bool,
  disabled: PropTypes.bool,
  unit: PropTypes.string,
  start: PropTypes.number.isRequired,
  step: PropTypes.number.isRequired,
  min: PropTypes.number.isRequired,
  max: PropTypes.number.isRequired,
  precision: PropTypes.number.isRequired,
  offset: PropTypes.number.isRequired,
  setValueByInput: PropTypes.func.isRequired,
  rangeMouseDown: PropTypes.func.isRequired,
  rangeMouseMove: PropTypes.func.isRequired,
  calcularPosition: PropTypes.func.isRequired,
  mode: PropTypes.string,
};

ViewBasic.defaultProps = {
  color: 'none',
  backgroundColor: 'none',
  inverted: false,
  disabled: false,
  unit: '',
  mode: null,
};
